import React, { useState } from 'react';
import { HotelLabel, HotelProps } from '@msc-b2c/interfaces/types';
import { Accordion, Text } from '@msc-b2c/shared-components';
import styles from '../stateroomdetails.module.scss';

const Hotel: React.FC<HotelProps> = ({
  hotelSectionIcon,
  hotelSectionTitle,
  hotelData,
  hotelLabels,
  viewDetailsHotelLabel,
  openViewDetailsHotelIcon,
  closeViewDetailsHotelIcon,
  labelsMap,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const hotelDetails = (hotelLabels ?? [])
    .map((element: HotelLabel) => {
      let value = '';

      switch (element.type) {
        case 'hotelCode':
          value = hotelData.code ?? '';
          break;
        case 'hotelName':
          value = labelsMap[hotelData.code]?.description ?? hotelData.name;
          break;
        case 'location':
          value = hotelData.location?.description ?? '';
          break;
        case 'roomCategory':
          value = hotelData.room?.categoryCode ?? hotelData.room?.categoryDescription ?? '';
          break;
        case 'roomOccupancy':
          value = hotelData.room?.occupancyCode ?? hotelData.room?.occupancyDescription ?? '';
          break;
        case 'checkInDate':
          value = hotelData.checkInDate ?? '';
          break;
        case 'checkOutDate':
          value = hotelData.checkOutDate ?? '';
          break;
        case 'vendorCode':
          value = hotelData?.supplierCode ?? '';
          break;
        case 'status':
          value = hotelData.bookingStatus?.description ?? '';
          break;
      }

      return element.label && value ? { label: element.label, value } : null;
    })
    .filter((item): item is { label: string; value: string } => item !== null);

  return (
    <Accordion
      question={hotelSectionTitle}
      answer=""
      isOpen={isOpen}
      autoClose={false}
      openingIcon={openViewDetailsHotelIcon}
      closingIcon={closeViewDetailsHotelIcon}
      multi={true}
      onToggle={() => setIsOpen((prev) => !prev)}
      viewDetailsLabel={viewDetailsHotelLabel}
      questionIcon={hotelSectionIcon}
      styleOption={styles.includedWithBookingAccordion}
    >
      <div className={styles.hotelDetailsContainer}>
        <div className={styles.hotelDetailsContent}>
          {hotelDetails.map(({ label, value }, index) => (
            <div
              key={`${label}-${index}`}
              className={styles.hotelDetailsElement}
            >
              <Text
                text={`${label}`}
                styleOption={`${styles.hotelDetailsLabel}`}
              />
              <Text text={value} />
            </div>
          ))}
        </div>
      </div>
    </Accordion>
  );
};

export default Hotel;
